import { render, staticRenderFns } from "./ChangeAdministratorPasswordForm.vue?vue&type=template&id=bb9b2256&scoped=true&"
import script from "./ChangeAdministratorPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangeAdministratorPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAdministratorPasswordForm.vue?vue&type=style&index=0&id=bb9b2256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b2256",
  null
  
)

export default component.exports